module.exports = __webpack_public_path__ + "static/media/Segoe UI.9a293118.woff";